import { AppProvider } from "@/app/provider";
import { router } from "@/app/router";
import { RouterProvider } from "@tanstack/react-router";
import { useAuth } from "oidc-react";
import { useEffect } from "react";

function RoutedApp() {
  const auth = useAuth();

  // Route loaders read `auth` from router context, so they have to re-run
  // whenever the session changes.
  useEffect(() => {
    void router.invalidate();
  }, [auth.userData, auth.isLoading]);

  return <RouterProvider router={router} context={{ auth }} />;
}

export function App() {
  return (
    <AppProvider>
      <RoutedApp />
    </AppProvider>
  );
}
